// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"1ddee699","136":"b0092753"}[chunkId] + ".chunk.css";
};